
export default class accessibleDesktopNav
{

	constructor () {
        this.currentDropdown = null;
        this.clicked = false;

        this.elements = {};
        this.elements.$html = $('html');
        this.elements.$nav = $('.desktop-nav-js');
        this.elements.$submenuToggleButton = this.elements.$nav.find('.toggle-submenu-js');

        this._bindEventListeners();
    }

    openSubmenu ( event ) {
        let eventType = event.type;
        let keyPressed = event.keyCode || event.which;

        if (eventType === 'click'
            || eventType === 'mouseover'
            || (eventType === 'keydown' && keyPressed === 67)
        ) {
            let button = event.currentTarget;

            // If there is a dropdown currently open, we need to do some checks.
            if ( this.currentDropdown ) {
                // If mousing over the dropdown that is currently open, do nothing and leave it open.
                if ( this.currentDropdown.contains(button) && (eventType === 'mouseover') ) {
                    return;
                }

                // If mouse leaves the clicked dropdown, do nothing and leave the dropdown open.
                if ( this.currentDropdown.contains(button) && eventType === 'mouseout' && this.clicked ) {
                    return;
                }

                // If clicking on the current dropdown, that was opened on 'hover', then check to see if it was
                //  'clicked' to stay open.  If it was, then close it, if not, then open it and set the 'clicked' flag
                //   to true to prevent toggling the dropdown off when hoving out.  Hovering over another dropdown
                //   button will cause this to close.
                if ( this.currentDropdown.contains(button) && eventType === 'click' ) {
                    return !this.clicked ? this.clicked = true : this._closeDropdowns();
                }

                // If the current button isn't already open, check to see if other are.  If so, close them.
                if ( !this.currentDropdown.contains(button) ) {
                    this._closeDropdowns();
                }
            } else if ( eventType === 'click' && !this.clicked ) {
                this.clicked = !this.clicked;
            }

            // Toggle submenu visibility and aria-*.
            let open = button.nextElementSibling.classList.toggle('active');
            button.setAttribute('aria-expanded', open.toString());

            // Tell the class where we are.
            this.currentDropdown = open ? button.parentElement : null;
        }
    }

    _closeDropdowns () {
        let button = this.currentDropdown.children[0];
        this.currentDropdown = null;
        this.clicked = false;

        button.setAttribute('aria-expanded', button.nextElementSibling.classList.toggle('active').toString());
    }

    _checkFocus ( event ) {
        let keyPressed = event.keyCode || event.which;

        // If there isn't a menu open, exit early.
        if ( !this.currentDropdown ) {
            return;
        }

        // If we tab outside of an expanded submenu, close the expanded submenu.
        if ( event.type === 'keyup' && keyPressed === 9 ) {
            if ( !this.currentDropdown.contains(event.target) ) {
                this._closeDropdowns();
            }
        }

        // If clicking or mousing outside of this menu, close all submenus.
        if ( (event.type === 'click' || (event.type === 'mouseover' && !this.clicked))
            && !this.currentDropdown.contains(event.target)
        ) {
            this._closeDropdowns();
        }
    }

    _bindEventListeners () {
        this.elements.$html.on('click keyup mouseover', event => this._checkFocus(event));
        this.elements.$submenuToggleButton.on('click keydown mouseover mouseout', event => this.openSubmenu(event));
    }
}
